<template>
  <x-dialog
    width="50%"
    :dialogTitle="dialogTitle"
    :dialogState="showDialog"
    dataTestId="dataTestId"
    @toggleModal="closeDialog"
    :actions="{
      show: true,
      secondaryButtonFunction: closeDialog,
      primaryButtonFunction: handleCreateNewOrg,
      primaryButtonShow: true,
      secondaryButtonText: 'Cancel',
      primaryButtonText: 'Create'
    }"
  >
    <template slot="dialog_data">
      <v-form v-model="formValid">
        <v-card-text class="px-8">
          <v-row class="org-tab align-center">
            <v-col md="12">
              <span class="formInputLabel mt-0">Organization Name*</span>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            align="center"
            :data-test-id="`${dataTestId}__org-name-input-wrapper`"
          >
            <v-text-field
              solo
              dense
              flat
              height="52px"
              background-color="#E5E5E5 !important"
              v-model="addNewOrgModel.name"
              required
              :rules="rules.name"
            ></v-text-field>
          </v-row>
          <!-- :counter="10" -->

          <v-row class="org-tab align-center">
            <v-col md="12">
              <span class="formInputLabel">VAR Status*</span>
            </v-col>
          </v-row>
          <v-row
          class="positionRelative"
            align="center"
            no-gutters
            :data-test-id="`${dataTestId}__var-status-select-wrapper`"
          >
            <v-select
              :items="varStatusList"
              v-model="addNewOrgModel.varStatus"
              item-value="id"
              item-text="text"
              filled
              dense
              solo
              flat
              height="52px"
              background-color="#E5E5E5 !important"
              :attach="
                `[data-test-id='${dataTestId}__var-status-select-wrapper']`
              "
            ></v-select>
          </v-row>

          <v-row class="org-tab align-center">
            <v-col md="12">
              <span class="formInputLabel">Organization ID(optional)</span>
            </v-col>
          </v-row>
          <v-row align="center" no-gutters :data-test-id="`${dataTestId}__org-id-input-wrapper`">
            <v-text-field
              solo
              dense
              flat
              height="52px"
              background-color="#E5E5E5 !important"
              v-model="addNewOrgModel.orgId"
            ></v-text-field>
          </v-row>
        </v-card-text>
      </v-form>
    </template>
  </x-dialog>
</template>

<script>
import EventBus from '@/EventBus';
import UserService from '../../../services/UserService';

export default {
  props: ['addOrgDialog', 'orgDetails'],
  data() {
    return {
      formValid: false,
      rules: {
        name: [v => !!v || 'Name is required'],
        newOrgId: [
          v => (v || '').match('') || !!v || 'Organization name is required',
          v =>
            (v || '').match('') ||
            (v || '').match(/^[A-Za-z0-9_-]+$/) ||
            'Only letters, numbers, hyphen and underscore are allowed.'
        ]
      },
      dialogTitle: 'Add new Organization',
      addNewOrgModel: {
        name: '',
        orgId: '',
        parentOrgId: '',
        varStatus: 'NOT_A_VAR'
      },
      varStatusList: [
        {
          id: 'NOT_A_VAR',
          text: 'Not a VAR'
        },
        {
          id: 'VAR_WHO_CAN_ADD_VARS',
          text: 'Can Add VARs'
        },
        {
          id: 'VAR_WHO_CANNOT_ADD_VARS',
          text: 'VAR Cannot Add VARs'
        }
      ],
      showDialog: false,
      dataTestId: 'add-org-dialog'
    };
  },
  created: function() {
    document.addEventListener('keyup', this.escapeKeyListener);
  },
  destroyed: function() {
    document.removeEventListener('keyup', this.escapeKeyListener);
  },
  mounted() {
    this.showDialog = this.addOrgDialog;
    this.addNewOrgModel.parentOrgId = this.orgDetails.orgId;
  },
  methods: {
    escapeKeyListener: function(evt) {
      if (evt.keyCode === this.escapeKeyCode && this.showDialog) {
        this.closeDialog();
      }
    },
    async handleCreateNewOrg() {
      if (!this.formValid) {
        this.snackbar('error', this.$message.FILL_FIELDS);
        return false;
      }
      try {
        await UserService.createOrg(this.addNewOrgModel);
        this.snackbar(
          'success',
          `Organization ${this.addNewOrgModel.name} created successfully.`
        );
        // refresh left panel also
        EventBus.$emit('refreshOrgList', true);
        this.closeDialog();
      } catch (err) {
        if (!err.response.data.success) {
          const errors = err.response.data.errors;
          this.snackbar('error', errors[0].message);
        } else {
          this.snackbar('error', this.$message.ORG_ADD_ERROR);
        }
      }
    },
    closeDialog() {
      this.showDialog = false;
      this.$emit('closeOverlay', true);
    }
  }
};
</script>

<style scoped>
.v-input__control .v-text-field__details {
  display: block !important;
}
.org-tab {
  box-shadow: none;
}

.fname > div.v-input__control {
  padding-right: 10px !important;
}

.user-dropdown {
  background: rgb(229, 229, 229) !important;
  border-color: rgb(229, 229, 229) !important;
}

.theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
  border: 0 !important;
}
</style>
